import Img from "~/components/common/img";
import MainButton from "~/components/common/mainButton";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { PrivateLocationType } from "~/types/location/location.types";
import { locationToColors, locationToNames } from "~/utils/constants/locations";
import { getLanguage } from "~/utils/functions/language.function";

import styles from "./index.module.scss";

type Props = {
  privateLocation: PrivateLocationType;
};

const PrivateLocation = ({ privateLocation }: Props) => {
  const { language } = useLanguage();

  const translation =
    language === "En" ? englishTranslations : frenchTranslations;

  const description = getLanguage(
    privateLocation,
    "description",
    language
  ) as string;

  return (
    <div className={styles.container}>
      <div
        className={`${styles.imageContainer} ${
          description && styles.imageContainerWithDescription
        }`}
      >
        <Img src={privateLocation.picturePath} alt={privateLocation.name} />

        <p className={styles.descriptionContainer}>
          <p className={styles.description}>{description}</p>
        </p>
        <MainButton
          className={styles.locationCorner}
          style={{ color: locationToColors[privateLocation.location] }}
        >
          <>{getLanguage(privateLocation, "name", language)}</>
        </MainButton>
      </div>
      <div className={styles.caption}>
        <div className={styles.captionLine}>
          <div className={styles.captionKey}>
            {translation.privateEventsPage.form.venue}
          </div>
          <div className={styles.captionValue}>
            {locationToNames[privateLocation.location]}
          </div>
        </div>
        <div className={styles.captionLine}>
          <div className={styles.captionKey}>Participants</div>
          <div className={styles.captionValue}>
            {privateLocation.capacityNumber}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateLocation;
